import { render, staticRenderFns } from "./SimpleLoading.vue?vue&type=template&id=0d5991f3&"
import script from "./SimpleLoading.vue?vue&type=script&lang=js&"
export * from "./SimpleLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports